"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RadioGroup.scss");
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.renderChildren = function () {
            var _a = _this.props, children = _a.children, options = _a.options;
            return React.Children.map(children, function (child) {
                return React.cloneElement(child, __assign(__assign({}, _this.radioItemProps), { error: child.props.error ? child.props.error : _this.radioItemProps.error, selected: _this.state.selected === child.props.value, spacing: child.props.last
                        ? 0
                        : options
                            ? options.spacing
                                ? options.spacing
                                : 8
                            : 8 }));
            });
        };
        _this.handleChange = function (event) {
            _this.setState({ selected: event.currentTarget.value }, function () {
                var onChange = _this.props.onChange;
                var selected = _this.state.selected;
                if (onChange) {
                    onChange(selected);
                }
            });
        };
        _this.handleKeyPress = function (value) {
            _this.setState({ selected: value }, function () {
                var onChange = _this.props.onChange;
                var selected = _this.state.selected;
                if (onChange) {
                    onChange(selected);
                }
            });
        };
        _this.render = function () {
            var _a = _this.props, error = _a.error, errorMessage = _a.errorMessage, options = _a.options, testId = _a.testId, title = _a.title;
            var elementsDirection = options && options.elementsDirection && options.elementsDirection === "column"
                ? "flex-column"
                : "";
            return (React.createElement("div", { "data-testid": testId, className: ["flex", elementsDirection].join(" ") },
                React.createElement("fieldset", { className: error ? "error" : undefined },
                    errorMessage && (React.createElement("div", { id: _this.hintId, className: [styles.radioGroupError, "formfield-msg", "mar-b-xs"].join(" "), "aria-live": "polite", "aria-atomic": error ? true : false, "aria-hidden": error ? false : true, tabIndex: -1 }, errorMessage)),
                    title && (React.createElement("legend", { className: "type-sm font-medium color-ui-black" },
                        React.createElement("span", null, title))),
                    _this.renderChildren())));
        };
        _this.getInitialRadioItemProps = function () {
            var _a = _this.props, className = _a.className, error = _a.error, errorMessage = _a.errorMessage, options = _a.options;
            var elementsDirection = options && options.elementsDirection;
            return {
                className: className,
                error: error,
                errorMessage: errorMessage,
                elementsDirection: elementsDirection,
                events: {
                    onChange: _this.handleChange.bind(_this),
                    onKeyPress: _this.handleKeyPress.bind(_this),
                },
                name: _this.props.name,
                hintId: _this.hintId,
            };
        };
        _this.guid = function () {
            return "" + _this.S4() + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + _this.S4() + _this.S4();
        };
        _this.S4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        };
        _this.state = {
            selected: props.defaultChecked || "",
        };
        _this.hintId = _this.guid();
        _this.radioItemProps = _this.getInitialRadioItemProps();
        return _this;
    }
    RadioGroup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, defaultChecked = _a.defaultChecked, persistentDefaultChecked = _a.persistentDefaultChecked;
        if (prevState.selected !== defaultChecked && persistentDefaultChecked) {
            this.setState({
                selected: defaultChecked ? defaultChecked : "",
            });
        }
    };
    return RadioGroup;
}(React.Component));
exports.default = RadioGroup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/RadioGroup/RadioGroup.js
// module id = 1515
// module chunks = 8